"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterIn = void 0;
const filter_helper_1 = require("./filter-helper");
const DEFAULT_STRATEGY = 'any';
const FilterIn = ({ property, value, matchStrategy }) => {
    const strategy = matchStrategy || DEFAULT_STRATEGY;
    const filterInCriteria = (item) => (item === null || item === void 0 ? void 0 : item[property]) && !filter_helper_1.checkIfMatchByStrategy(item === null || item === void 0 ? void 0 : item[property], value, strategy);
    return {
        any: {
            enter: (node, ctx) => {
                filter_helper_1.filter(node, ctx, filterInCriteria);
            },
        },
    };
};
exports.FilterIn = FilterIn;
